export default __webpack_public_path__ + "static/media/buttonBelep.392ab2a1.png";